'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _prep = require('./internal/prep');

var _prep2 = _interopRequireDefault(_prep);

var _every = require('./every');

var _every2 = _interopRequireDefault(_every);

var _get = require('./get');

var _get2 = _interopRequireDefault(_get);

var _size = require('./size');

var _size2 = _interopRequireDefault(_size);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _prep2.default)({
    name: 'shallowEquals',
    all: function all(other) {
        return function (value) {
            return (0, _size2.default)()(value) === (0, _size2.default)()(other) ? (0, _every2.default)(function (childValue, key) {
                return childValue === (0, _get2.default)(key)(other);
            })(value) : false;
        };
    }
});


//////////////////
// WEBPACK FOOTER
// ./~/unmutable/lib/shallowEquals.js
// module id = 393
// module chunks = 35783957827783